import React, { Component } from 'react';
import { CommunicationType } from '../../redux/auth/authTypes';

type AppProps = {
  communication?: CommunicationType;
}

const Communication = ({ communication }: AppProps) => {

  const address1 = communication?.address1;
  const address2 = communication?.address2;
  const address3 = communication?.address3;
  const city = communication?.city;
  const state = communication?.state;
  const workPhone = communication?.work_phone;
  const mobilePhone = communication?.mobile_phone;
  const postcode = communication?.postcode;
  const homePhone = communication?.home_phone;

  return (
    <div className="w-75">
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={address1 ? "active" : ""}
          >Address 1</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={address1}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={address2 ? "active" : ""}
          >Address 2</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={address2}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={address3 ? "active" : ""}
          >Address 3</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={address3}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={city ? "active" : ""}
          >City</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={city}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={state ? "active" : ""}
          >State</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={state}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={postcode ? "active" : ""}
          >Zipcode</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={postcode}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={workPhone ? "active" : ""}
          >Work Phone</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={workPhone}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={homePhone ? "active" : ""}
          >Home Phone</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={homePhone}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={mobilePhone ? "active" : ""}
          >Mobile Phone</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={mobilePhone}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
    </div>
  )
}

export default Communication;